<span class="status-badge" [ngClass]="'status-badge-' + statusCategory()">
  <mat-icon class="status-badge-icon">{{ icon() }}</mat-icon>
  <span class="status-badge-label">{{ label() || ('system.label.' + statusCategory() | translate) }}</span>
</span>
